import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppShellStateService {
  private readonly appChromeVisibleState = signal(true);

  public readonly appChromeVisible = this.appChromeVisibleState.asReadonly();

  public hideAppChrome(): void {
    this.appChromeVisibleState.set(false);
  }

  public showAppChrome(): void {
    this.appChromeVisibleState.set(true);
  }
}
